import { Seat } from '@core/models';
import {
  ANALYTICS_ITEM_CATEGORIES,
  AnalyticsItem,
} from '@core/services/analytics';

/**
 * Groups seats into one items[] row per section — the shape shared by add_to_cart,
 * remove_from_cart and begin_checkout (all fired before a transaction exists, from live
 * cart-session state). `price` is the section's unit price excluding fees; `quantity` is
 * the seat count in that section.
 */
export function buildCartItems(
  seats: Seat[],
  gameId: string,
  matchup: string
): AnalyticsItem[] {
  const seatsBySection = new Map<string, Seat[]>();
  for (const seat of seats) {
    const sectionSeats = seatsBySection.get(seat.section) ?? [];
    sectionSeats.push(seat);
    seatsBySection.set(seat.section, sectionSeats);
  }

  const items: AnalyticsItem[] = [];
  for (const [section, sectionSeats] of seatsBySection) {
    const firstSeat = sectionSeats[0];
    items.push({
      itemId: `${gameId}::${section}`,
      itemName: `${matchup} - ${section}`,
      itemCategory: ANALYTICS_ITEM_CATEGORIES.SEATS,
      price: firstSeat.price,
      quantity: sectionSeats.length,
    });
  }
  return items;
}
